import React, { useEffect, useRef, useState } from 'react';
import './manage-quests-landing.styles.scss';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useSelector } from 'react-redux';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { getQueryFromFirestore } from '@/utils/getDataFromDbSimplified';
import QuestsList from './quests-list.component';
import QuestForm from './quest-form.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';

const ManageQuestsLanding = ({
  gameData,
  gameElements,
  playerList
}) => {
  
  const membership = useSelector(state => state.userData.membership);
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [questsFromDb, setQuestsFromDb] = useState(null);
  const [questsRetrieved, setQuestsRetrieved] = useState(false);
  const navigate = useNavigate();
  let questsListener;
  const questsRef = useRef();
  const location = useLocation();

  useEffect(() => {

    changeDocumentTitle('Manage Quests - ' + gameData?.gameName || 'Manage Quests');

    return () => {
      if (questsListener) questsListener();
    }
  }, [])

  useEffect(() => {
    if (!membership) return;
    checkMembership();
  }, [membership])

  useEffect(() => {
    if (!gameData || questsRetrieved) return;
    getGameElementsToManage();
    setQuestsRetrieved(true);
  }, [gameData])

  function checkMembership() {
    const element = 'quests'
    const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'element': element })
    // console.log(res);
    if (res.disabled) {
      let message = ''
      const planRest = membershipRestrictions[membership.membership];
      if (res.disabledReason.includes(element)) {
        message = `While using the ${planRest.title}, you are not able to access ${properCase(element)}.`;
      }
      setShowUpgradeModal(message)
    }
  }

  function getGameElementsToManage() {
    if (location.pathname.includes('/preview/manager/')) {
      const questObj = {};
      Object.values(gameElements)
        .filter(e => e.type === 'quest' && e.status === 'active')
        .forEach(e => {
          questObj[e.id] = e;
        });
      setQuestsFromDb(questObj);
      return;
    }
    getQueryFromFirestore({
      "path": `games/${gameData.gameId}/gameElements`,
      "queryArray": [{
        "field": "type",
        "operator": "==",
        "value": "quest"
      }],
      "callback": callback,
      "handleListener": handleListener
    })
    function callback(data) {
      questsRef.current = {
        ...questsRef.current,
        ...{ [data.id]: data }
      }
      setQuestsFromDb(questsRef.current);
    }
    function handleListener(data) {
      questsListener = data;
    }
  }

  return (
    <div className='manage-quests-landing'>
      <Routes>
        <Route path='' element={
          <div className='g-card quests-card'>
            <BackButton cancel={() => navigate(-1)} />
            <div className="g-space-1"></div>
            <div className='card-title'>
              <ImageContainer src='/images/icons/quests.png' className='head-icon' />
              Create and Edit Quests</div>
            <hr />
            <div className='quests-landing-content'></div>
            <QuestsList
              gameData={gameData}
              gameElements={gameElements}
              questsFromDb={questsFromDb} />

          </div>
        }></Route>
        <Route path='create' element={
          <QuestForm
            gameData={gameData}
            gameElements={gameElements}
            playerList={playerList}
            questsFromDb={questsFromDb} />
        }></Route>
        <Route path='edit/:elementPath' element={
          <QuestForm
            gameData={gameData}
            gameElements={gameElements}
            playerList={playerList}
            questsFromDb={questsFromDb} />
        }></Route>
        <Route path="*" element={<Navigate replace to="/404" />} />
      </Routes>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default ManageQuestsLanding